import Delete from "@mui/icons-material/Delete";
import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useMenu, UseMenuProps } from "../../hook/menu";
import {
  useAddNotebookPage,
  useDeleteNotebookPage,
  useFetchNotebookPage,
  useMovePage,
  useNotebookPage,
  useSelectedNotebookPageId,
} from "../../hook/page";
import { NotebookPage } from "../../types/note";
import { MoveBlockMenu } from "./page/block";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";

export const AddPageMenu: React.FC<UseMenuProps & { folderId: string }> = ({
  open,
  onClose,
  folderId,
  anchorEl,
}) => {
  const [name, setName] = useState<string>("");
  const addNotebookPage = useAddNotebookPage();

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <MenuItem disabled>
        <ListItemText>Add Page</ListItemText>
      </MenuItem>
      <MenuItem>
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          label="Name"
        />
      </MenuItem>
      <MenuItem>
        <ListItem>
          <Button
            onClick={() => {
              addNotebookPage({ folderId, name });
              onClose();
            }}
          >
            Save
          </Button>
        </ListItem>
      </MenuItem>
    </Menu>
  );
};

export const EditPageMenu: React.FC<UseMenuProps & { pageId?: string }> = React.memo(({
  pageId,
  ...props
}) => {
  const { onClose } = props;
  const { page: notebookPage } = useNotebookPage(pageId);
  const [selectedPageId, setSelectedPageId] = useSelectedNotebookPageId();
  const fetchPage = useFetchNotebookPage(selectedPageId);
  const deletePage = useDeleteNotebookPage();
  const isSelected = selectedPageId === pageId;
  const movePage = useMovePage();
  const {
    anchorEl: anchorElMove,
    handleOpen: handleOpenMove,
    onClose: onCloseMove,
    open: openMove,
    setAnchorEl: setAnchorElMove,
  } = useMenu();
  const moveFunction = (page: NotebookPage) =>
    movePage({
      "source-page-id": notebookPage?.["page-id"]!,
      "destination-page-id": page["page-id"],
    });

  return (
    <>
      <MoveBlockMenu
        anchorEl={anchorElMove}
        moveFunction={moveFunction}
        onClose={onCloseMove}
        open={openMove}
      />
      <Menu {...props}>
        <MenuItem disabled>
          <ListItemText>Page Options</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (!notebookPage) return;
            if (isSelected) {
              setSelectedPageId(undefined);
            }
            onClose();
            return deletePage(notebookPage).then(() => {
              if (isSelected) {
                setSelectedPageId(undefined);
              } else {
                return fetchPage();
              }
            });
          }}
        >
          <ListItemIcon>
            <Delete color="primary" />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
        <MenuItem
          sx={{ width: "15rem" }}
          onClick={(e) => {
            handleOpenMove(e);
            // onClose();
          }}
          // ref={(e) => {
          //   setAnchorElMove(e);
          // }}
        >
          <ListItemIcon>
            <DriveFileMoveIcon color="primary" fontSize="small" />
          </ListItemIcon>
          <ListItemText>Move</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
});
